// import React from "react"

import React from "react"
import { ModalProviderContext, ModalProviderProps } from "./ModalProviderContext"

const useModal = (): ModalProviderProps => React.useContext(ModalProviderContext)
export default useModal
